import { render, staticRenderFns } from "./NavbarDashboard.vue?vue&type=template&id=128db745&"
import script from "./NavbarDashboard.vue?vue&type=script&lang=js&"
export * from "./NavbarDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports